/*
 *
 * Package: `@dbh/redux-form-components-theme`.
 *
 */const THEME_KEY_REDUX_FORM_SUBMIT_BUTTON="reduxFormSubmitButton";const modifyReduxFormSubmitButtonTheme=()=>({[THEME_KEY_REDUX_FORM_SUBMIT_BUTTON]:{margin:0}});

export { THEME_KEY_REDUX_FORM_SUBMIT_BUTTON, modifyReduxFormSubmitButtonTheme as default };
